import { useTheme } from "@/context/ThemeContext";
import { Moon, Sun } from "lucide-react";

// Me1 — one discoverable theme control, consistent in both dashboards (lives in the Shell sidebar).
export default function ThemeToggle({ compact }) {
  const { resolved, toggle } = useTheme();
  const dark = resolved === "dark";
  return (
    <button className="k-control" data-testid="theme-toggle" onClick={toggle}
      aria-label={dark ? "Switch to light theme" : "Switch to dark theme"}
      style={{ display: "inline-flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13,
        justifyContent: compact ? "center" : "flex-start", width: compact ? "auto" : "100%",
        padding: compact ? "8px 10px" : undefined, minHeight: 0 }}>
      {dark ? <Sun size={14} /> : <Moon size={14} />}
      {!compact && <span>{dark ? "Light theme" : "Dark theme"}</span>}
    </button>
  );
}
